import { workLogs } from "@/api/logs/useWorksLogsQuery";
import { useLocalStorage } from "@/context/LocalStorageProvider";
import useFetcher from "@/hooks/useFetcher";
import { usePaginationStore } from "@/store/pagenation.store";
import { WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum } from "@sizlcorp/sizl-api-document/dist/models";

export const usePalletLogsFormFetch = () => {
  const { workId } = useLocalStorage();
  const { currentPage } = usePaginationStore((state) => ({
    currentPage: state.currentPage,
  }));
  const { queryKey, queryFn } = workLogs.get({
    query: {
      $and: [
        { workId: workId ?? 0 },
        { parentWorkLogId: { $eq: null } },
        {
          $or: [
            {
              workLogType: {
                $eq: WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.SPLIT_LOT,
              },
            },
          ],
        },
        {
          $or: [
            { description: { $ne: "ACTION" } },
            { description: { $eq: null } },
          ],
        },
      ],
    },
    populate: [
      "itemUnit",
      "defectName",
      "creatorUser",
      "alreadyCanceledWorkLog",
      "lotData",
    ],
    page: currentPage,
    sort: "-id",
  });

  // useFetcher를 사용하여 queryKey와 queryFn을 설정
  const { data, Fetcher } = useFetcher({
    queryKey: queryKey,
    queryFn: queryFn,
  });

  return { data, Fetcher };
};
